import { CoverageChipGroup as CoverageChipGroupSchema } from '@/schemas/sceneDataSchema';
import { BaseChipElement } from './BaseChipElement';

export const CoverageChipFormElement = ({ component }: { component: CoverageChipGroupSchema }) => {
  const value = '';
  return (
    <BaseChipElement
      onChange={() => {}}
      options={component.options}
      value={value}
    />
  );
};
